/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Ui
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/14/2016
 * Copyright All Rights Reserved
 */

import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction';
import throttle from 'lodash/throttle';
import config, { REDUX_LOGGER_ENABLED } from 'support/config';
import { loadState, saveState } from 'support/localStorageHelpers';
import rootReducer from 'reducers';

let middleware = [thunkMiddleware];
if (config(REDUX_LOGGER_ENABLED)) {
  middleware = [...middleware, createLogger()];
}

/**
 * Read persisted data from local storage
 */
const persistedState = loadState();

function configureStore() {
  return createStore(
    rootReducer,
    persistedState,
    composeWithDevTools(
      applyMiddleware(...middleware)
    )
  );
}

const store = configureStore();

/**
 * Listen for changes to the Redux store and, when throttle allows, save slices of the store
 * to local storage
 */
store.subscribe(throttle(() => {
  const { value, isBeingFetched, user } = store.getState().token;
  const { entities } = store.getState();
  saveState({ token: { value, isBeingFetched, user }, entities });
}, 1000));

export default store;
